const theme = {
	colors: {
		background: "rgb(255, 247, 240)",
		orange: "rgb(254, 125, 48)",
		orangeSaturated: "rgb(254, 95, 0)",
	},
};

export default theme;
